import { normalize } from "normalizr";
import {filter} from "./schema";

export const getFilterList = {
  success: (response) => {
    return normalize(response, [filter]);
  },
};
